import { Component, ElementRef, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { LoadingController, NavParams } from "ionic-angular";
import { NavController } from 'ionic-angular';
import { stringify } from '@angular/core/src/facade/lang';
import * as _ from 'lodash';

@Component({
  templateUrl: 'speedTest.html',
  selector: 'speed-test'
})
export class SpeedTestPage implements OnInit {
  public pageDome: HTMLElement;
  title: string = "Kiểm tra tốc độ máy chủ";
  arrDomainTest = ["https://m.loto188.com", "https://m.loto288.com", "https://m.loto388.com", "https://m.loto588.com", "https://m.loto688.com", "https://m.loto788.com", "https://m.loto988.com"];
  arrSort = [];
  countTemp = 0;
  trustedUrl: any;
  loading: any;
  serverList: any = [];
  $elWrap: any;
  constructor(private nav: NavController, public loadingCtrl: LoadingController, private navParams: NavParams, private el: ElementRef, ) {
    this.pageDome = el.nativeElement;
  }

  ngOnInit() {
    this.$elWrap = this.pageDome.querySelector('.moto__testspeed');
    this.testSpeed();
  }

  testSpeed() {
    // this.pageDome.querySelector('#loading__emu').setAttribute("style", "opacity: 1");
    let _self = this;
    var _loop = function loop(i, len) {
      let url = _self.arrDomainTest[i];
      let process = 0;
      let objUrlLoad = {};
      _self.htmlLine(url);
      _self.ping(url, i)
        .then(function (data: number) {
          objUrlLoad['idx'] = i;
          if (+data <= 1000) { // very fast
            objUrlLoad['class'] = 'speed__1';
          } else if (1000 < +data && +data <= 3000) { // fast
            objUrlLoad['class'] = 'speed__2';
          } else if (3000 < +data && +data <= 5000) { // normal
            objUrlLoad['class'] = 'speed__3';
          } else { // slow
            objUrlLoad['class'] = 'speed__4';
          }

          objUrlLoad['timeLoad'] = `${(data / 2)}MS`;
          objUrlLoad['href'] = url;

          var timeInterVal = +data / 100;
          objUrlLoad['timeOut'] = timeInterVal;

          var processInterVal = setInterval(function () {
            var flag = true;
            if (process < 100) {
              process += 1;
              flag = false;
            }
            objUrlLoad['process'] = 100 - timeInterVal;
            if (flag) {
              clearInterval(processInterVal);
              _self.processLine(objUrlLoad);
            }
          }, timeInterVal);
        }).catch(function (err) {
          // debugger;
        });
    };

    for (let i = 0, len = this.arrDomainTest.length; i < len; i++) {
      _loop(i, len);
    }
  }

  processLine(obj) {
    this.countTemp += 1;
    const elTypeBet = this.pageDome.querySelector('.moto__testspeed');
    let $elLine = elTypeBet.querySelectorAll('.speed__line');
    const timeLoad = obj.timeLoad;
    const classProcess = obj.class;
    const process = obj.process;
    const idx = obj.idx;
    $elLine[idx].querySelector('.numSpeed').innerHTML += `${timeLoad}`;
    $elLine[idx].setAttribute('data-time', timeLoad);
    $elLine[idx].setAttribute('data-process', process);
    $elLine[idx].classList.add(classProcess);
    if (this.countTemp === this.arrDomainTest.length) {
      // remove non-sort list
      const tempArrayEle = Array.from($elLine);
      tempArrayEle.forEach(element => {
        this.$elWrap.removeChild(element);
      })
      // sort list
      $elLine = _.sortBy($elLine, (item) => {
        return parseInt(item.getAttribute('data-time').split('MS')[0]);
      });
      // append new list
      const arrayEle = Array.from($elLine);
      arrayEle.forEach(element => {
        this.$elWrap.append(element);
        let time = parseInt(element.getAttribute('data-time').split('MS')[0]),
          process = parseInt(element.getAttribute('data-process'));
          setTimeout(function () {
            element.querySelector('.speed__run').setAttribute("style", `width: ${process}%`);
        }, time);
      });
    }
  }

  htmlLine(href) {
    let html =
      '<div class="speed__line clearfix">\n' +
      '    <button class="btn__speed pull-left">' + href + '</button>\n' +
      '    <div class="pull-left num__speed"><span class="numSpeed"></span></div>\n' +
      '    <div class="speed__process pull-left"><div class="speed__run"></div></div>\n' +
      '    <a href="' + href + '" class="pull-right speed__link btn__speed">Truy cập</a>\n' +
      '</div>';
    let temp = document.createElement('div');
    temp.innerHTML = html;
    while (temp.firstChild) {
      this.$elWrap.append(temp.firstChild);
    }
  }

  requestImg(url) {
    var imgName = '/images/speed.gif';
    var promise = new Promise(function (resolve, reject) {
      var img = new Image();
      img.onload = function () {
        resolve(img);
      };
      img.onerror = function () {
        reject(url);
      };
      img.src = url + imgName + '?clearnCache=' + Math.floor((1 + Math.random()) * 0x10000).toString(16);
    });
    return promise;
  }

  ping(url, idx) {
    let _self = this;
    let promise = new Promise(function (resolve, reject) {
      let startTime = new Date().getTime();
      let response = function response() {
        let getTimeLoad = new Date().getTime() - startTime;
        resolve(getTimeLoad);
      };
      _self.requestImg(url)
        .then(response)
        .catch(function (err) {
          var objError = {};
          objError['idx'] = idx;
          objError['href'] = err;
          objError['timeLoad'] = 'Error';
          objError['class'] = 'speed__4';
          objError['process'] = 100;
          _self.processLine(objError);
        });
    });
    return promise;
  }

}



// WEBPACK FOOTER //
// ./src/pages/speedTest/speedTest.ts